// src/components/AvailabilityCalendar.jsx
import React from 'react';
import { DayPicker } from 'react-day-picker';
import { startOfDay } from 'date-fns';
import 'react-day-picker/dist/style.css';
import Spinner from '../components/Spinner';

const localDateFromDateOnly = (dateString) => {
  const [year, month, day] = String(dateString).slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return undefined;
  return new Date(year, month - 1, day);
};

const localDateFromUtcInstant = (value) => {
  if (!value) return undefined;

  const rawValue = String(value).trim();
  const normalizedValue = rawValue.includes('T')
    ? rawValue
    : `${rawValue.replace(' ', 'T')}${/[zZ]|[+-]\d{2}:?\d{2}$/.test(rawValue) ? '' : 'Z'}`;
  const date = new Date(normalizedValue);

  if (Number.isNaN(date.getTime())) return undefined;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

function AvailabilityCalendar({
  onDateSelect,
  selectedDate,
  onMonthChange,
  highlightDays,
  isLoading,
  currentMonth
}) {
  const selectedLocalDate = selectedDate
    ? localDateFromDateOnly(selectedDate)
    : undefined;

  const highlightedLocalDates = highlightDays
    .map(localDateFromUtcInstant)
    .filter(Boolean);

  const highlightedModifier = {
    highlighted: (date) =>
      highlightedLocalDates.some(highlightedDate =>
        highlightedDate.toDateString() === date.toDateString()
      )
  };

  const disabledModifier = { before: startOfDay(new Date()) };

  const handleMonthChange = (newMonth) => {
    if (onMonthChange) {
      onMonthChange(newMonth);
    }
  };

  const handleDayClick = (day) => {
    if (!day) return;

    // manually check if clicked day is in highlighted dates
    const isHighlighted = highlightedLocalDates.some(highlightedDate =>
      highlightedDate.toDateString() === day.toDateString()
    );

    if (isHighlighted) {
        const utcDateString = day.toISOString().slice(0, 10);
        onDateSelect(utcDateString);
    }
  };

  return (
    // <div className="relative border rounded-lg p-4 bg-primary shadow-sm flex flex-col items-center justify-center">
    <div className="relative flex flex-col items-center justify-center">
      {isLoading && (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-10">
            <Spinner text="Loading dates..." />
        </div>
      )}
      <DayPicker
        mode="single"
        selected={selectedLocalDate}
        onSelect={(day) => handleDayClick(day)}
        month={currentMonth}
        onMonthChange={handleMonthChange}
        modifiers={highlightedModifier}
        modifiersClassNames={{
          highlighted: 'rdp-day_highlighted',
          selected: 'rdp-day_selected'
        }}
        disabled={disabledModifier}
        fixedWeeks
      />
      <p className="text-xs text-center text-gray-500 mt-2">
        Dates shown in your local timezone. Available days are highlighted.
      </p>
      {!isLoading && highlightedLocalDates.length === 0 && (
        <p className="text-sm text-center text-gray-600 mt-2">
          No available days are listed for this month. Try another month or provider.
        </p>
      )}
    </div>
  );
}

export default AvailabilityCalendar;
